module.exports = "<a *ngFor=\"let form of formSteps\"\n  routerLink=\"{{ form.id }}\"\n  routerLinkActive=\"active\"\n  [ngClass]=\"{ 'completed': isCompleted(form.id), 'inactive': isInactive(form.id), 'current': isActive(form.id) }\">\n    <span>{{ form.title }}</span>\n  </a>\n"


//////////////////
// WEBPACK FOOTER
// ./resources/themes/pandax/bobtail/app/coverage-form/navigation/navigation.component.html
// module id = 565
// module chunks = 1